export default "__VITE_ASSET__B9sp3Ee___"